var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'CoreGroupbuyingsListV2'
      }
    }
  }, [_vm._v("團購管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("查看團購訂單")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("查看團購")])]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.status === _vm.GROUPBUYING_STATUS.WAITING ? [_vm.checkPermission([_vm.consts.CORE_GROUPBUYING_LIST_VIEW]) ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "to": {
        name: 'CoreGroupbuyingsViewV2',
        params: {
          groupbuyID: _vm.groupbuyID
        }
      },
      "disabled": _vm.groupbuying.type === _vm.GROUPBUYING_TYPE.MAIN
    }
  }, [_vm._v("查看團購")]) : _vm._e(), _vm.checkPermission([_vm.consts.CORE_GROUPBUYING_MODIFY]) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "warning",
      "to": {
        name: 'CoreGroupbuyingsEditV2',
        params: {
          groupbuyID: _vm.groupbuyID
        }
      },
      "disabled": _vm.groupbuying.type === _vm.GROUPBUYING_TYPE.MAIN
    }
  }, [_vm._v("編輯團購")]) : _vm._e(), _vm.checkPermission([_vm.consts.CORE_GROUPBUYING_MODIFY]) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "inverse-danger",
      "disabled": _vm.groupbuying.type === _vm.GROUPBUYING_TYPE.MAIN
    },
    on: {
      "click": _vm.handleDelete
    }
  }, [_vm._v("刪除團購")]) : _vm._e()] : _vm._e(), _vm.status === _vm.GROUPBUYING_STATUS.GOING ? [_vm.checkPermission([_vm.consts.GROUPBUYING_STATUS_MODIFY]) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("結單")]) : _vm._e(), _vm.checkPermission([_vm.consts.GROUPBUYING_STATUS_MODIFY]) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("流團")]) : _vm._e(), _vm.checkPermission([_vm.consts.CORE_GROUPBUYING_LIST_VIEW]) ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "to": {
        name: 'CoreGroupbuyingsViewV2',
        params: {
          groupbuyID: _vm.groupbuyID
        }
      },
      "disabled": _vm.groupbuying.type === _vm.GROUPBUYING_TYPE.MAIN
    }
  }, [_vm._v("查看團購")]) : _vm._e(), _vm.checkPermission([_vm.consts.CORE_GROUPBUYING_MODIFY]) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "warning",
      "to": {
        name: 'CoreGroupbuyingsEditV2',
        params: {
          groupbuyID: _vm.groupbuyID
        }
      },
      "disabled": _vm.groupbuying.type === _vm.GROUPBUYING_TYPE.MAIN
    }
  }, [_vm._v("編輯團購")]) : _vm._e(), _vm.checkPermission([_vm.consts.GROUPBUYING_STATUS_MODIFY]) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handlePending
    }
  }, [_vm._v("暫停收單")]) : _vm._e()] : _vm._e(), _vm.status === _vm.GROUPBUYING_STATUS.CONFIRMED ? [_vm.checkPermission([_vm.consts.CORE_GROUPBUYING_LIST_VIEW]) ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "to": {
        name: 'CoreGroupbuyingsViewV2',
        params: {
          groupbuyID: _vm.groupbuyID
        }
      },
      "disabled": _vm.groupbuying.type === _vm.GROUPBUYING_TYPE.MAIN
    }
  }, [_vm._v("查看團購")]) : _vm._e(), _vm.checkPermission([_vm.consts.GROUPBUYING_STATUS_MODIFY]) ? _c('b-button', {
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleFinish
    }
  }, [_vm._v("完成團購")]) : _vm._e()] : _vm._e(), _vm.status === _vm.GROUPBUYING_STATUS.PENDING ? [_vm.checkPermission([_vm.consts.CORE_GROUPBUYING_LIST_VIEW]) ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "to": {
        name: 'CoreGroupbuyingsViewV2',
        params: {
          groupbuyID: _vm.groupbuyID
        }
      },
      "disabled": _vm.groupbuying.type === _vm.GROUPBUYING_TYPE.MAIN
    }
  }, [_vm._v("查看團購")]) : _vm._e(), _vm.checkPermission([_vm.consts.GROUPBUYING_STATUS_MODIFY]) ? _c('b-button', {
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("結單")]) : _vm._e(), _vm.checkPermission([_vm.consts.GROUPBUYING_STATUS_MODIFY]) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("流團")]) : _vm._e(), _vm.checkPermission([_vm.consts.GROUPBUYING_STATUS_MODIFY]) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleResume
    }
  }, [_vm._v("恢復收單")]) : _vm._e()] : _vm._e(), _vm.status === _vm.GROUPBUYING_STATUS.FINISHED ? [_vm.checkPermission([_vm.consts.CORE_GROUPBUYING_LIST_VIEW]) ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "to": {
        name: 'CoreGroupbuyingsViewV2',
        params: {
          groupbuyID: _vm.groupbuyID
        }
      },
      "disabled": _vm.groupbuying.type === _vm.GROUPBUYING_TYPE.MAIN
    }
  }, [_vm._v("查看團購")]) : _vm._e()] : _vm._e(), _vm.status === _vm.GROUPBUYING_STATUS.ARCHIVED ? [_vm.checkPermission([_vm.consts.CORE_GROUPBUYING_LIST_VIEW]) ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "to": {
        name: 'CoreGroupbuyingsViewV2',
        params: {
          groupbuyID: _vm.groupbuyID
        }
      },
      "disabled": _vm.groupbuying.type === _vm.GROUPBUYING_TYPE.MAIN
    }
  }, [_vm._v("查看團購")]) : _vm._e()] : _vm._e()], 2)]), _c('b-overlay', {
    staticClass: "d-inline-block w-100",
    attrs: {
      "show": _vm.isFetchGroupbuying,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('GroupbuyingsDetailInfo', {
    attrs: {
      "detailInfo": _vm.detailInfo,
      "getGroupbuying": _vm.getGroupbuying
    }
  })], 1), _c('div', {
    staticClass: "row d-flex mt-4 mb-2 justify-content-between align-items-center"
  }, [_c('h5', {
    staticClass: "col-12 col-xl-6 font-weight-bold m-0"
  }, [_vm._v("團購訂單")])]), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.groupbuying.orders,
      "fields": _vm.fields,
      "sort-by": _vm.sortBy,
      "busy": _vm.isFetchGroupbuyingOrders
    },
    on: {
      "update:sortBy": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function updateSortBy($event) {
        _vm.sortBy = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "cell(quantity)",
      fn: function fn(data) {
        return [_vm.displayEdit(data.item) ? _c('a', {
          attrs: {
            "href": ""
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.handleQuantity(data.item);
            }
          }
        }, [_vm._v(" " + _vm._s(data.item.quantity) + " ")]) : _c('span', [_vm._v(_vm._s(data.item.quantity))])];
      }
    }, {
      key: "cell(cancel)",
      fn: function fn(data) {
        return [_vm.displayCancel(data.item) ? _c('b-button', {
          attrs: {
            "href": "",
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.handleCancelOrder(data.item);
            }
          }
        }, [_vm._v("取消")]) : _vm._e()];
      }
    }, {
      key: "cell(redeem_code)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.getRedeemCodeStatus(data.item.redeem_code)) + " ")];
      }
    }])
  }), _vm.editQuantityData ? _c('GroupbuyingsQuantityModal', {
    attrs: {
      "show": _vm.isOpenQuantityModal,
      "data": _vm.editQuantityData,
      "groupbuying": _vm.groupbuying,
      "groupbuyingNumber": _vm.detailInfo.groupbuying_number
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.isOpenQuantityModal = $event;
      },
      "updated": function updated($event) {
        return _vm.getGroupbuying();
      }
    }
  }) : _vm._e(), _vm.isOpenGroupbuyingsLinkModal ? _c('GroupbuyingsLinkModal', {
    attrs: {
      "show": _vm.isOpenGroupbuyingsLinkModal,
      "detailInfo": _vm.detailInfo
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.isOpenGroupbuyingsLinkModal = $event;
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('b-pagination', {
    staticClass: "separated",
    attrs: {
      "total-rows": _vm.total,
      "per-page": _vm.perPage
    },
    on: {
      "change": _vm.handleChangePage
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }